import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="font-heading text-xl font-bold text-background-50 mb-4">073漫画网</h4>
              <p className="text-sm text-secondary-300 leading-relaxed">
                国内领先的在线漫画阅读平台，提供全职法师等海量高清漫画的免费阅读服务。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速导航</h4>
              <ul className="flex flex-col gap-2">
                <li><Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200">首页</Link></li>
                <li><Link to="/category/all" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200">漫画分类</Link></li>
                <li><Link to="/article/1" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200">全职法师</Link></li>
                <li><Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">热门推荐</h4>
              <ul className="flex flex-col gap-2">
                <li><Link to="/article/1" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200">全职法师</Link></li>
                <li><Link to="/article/2" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200">斗破苍穹</Link></li>
                <li><Link to="/article/3" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200">凡人修仙传</Link></li>
                <li><Link to="/article/4" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200">完美世界</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
              <ul className="flex flex-col gap-2">
                <li className="flex items-center gap-2 text-sm text-secondary-300">
                  <i className="ri-mail-line text-base"></i>
                  <span>contact@073comic.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-300">
                  <i className="ri-phone-line text-base"></i>
                  <span>0731-8888-8888</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-300">
                  <i className="ri-map-pin-line text-base"></i>
                  <span>湖南省长沙市岳麓区</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-secondary-400">
              &copy; 2018-2026 073漫画网 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="/about" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors duration-200">隐私政策</a>
              <a href="/about" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors duration-200">服务条款</a>
              <a href="/about" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors duration-200">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}